module.exports = "var appState = {\r\n  tiles: {\r\n    t20: {\r\n      id: 12,\r\n      // ... rest of the data for user 12\r\n    },\r\n    t21: {\r\n      id: 14,\r\n      // ... rest of the data for user 14\r\n    },\r\n\r\n    // ... if we open more tiles its data would go here\r\n  }\r\n};\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/appOkState.html
 ** module id = 276
 ** module chunks = 0
 **/